module.exports = __webpack_public_path__ + "img/nav_(1).db58acb8.png";